export const ROUTE_HOME = '/';
export const ROUTE_LOGIN = '/login';
export const ROUTE_SIGNUP = '/signup';
export const ROUTE_BROWSE = '/browse';
export const ROUTE_SEARCH = "/search";
export const ROUTE_FILTER = "/genre";
export const ROUTE_RESET = "/reset";
export const ROUTE_ADMIN = "/admin";
export const ROUTE_PROFILE = "/profile";
